import { Card, IconButton, Tooltip } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import { useEffect, useState } from "react";
import ApiCalls from "services/flick_erp_api_call";
import Info from "@mui/icons-material/Info";
import { ApprovalRounded, CallMissedOutgoingRounded, CrisisAlert, MissedVideoCall } from "@mui/icons-material";
import colors from "assets/theme/base/colors";

export function ApproveMissPunch({permissions,modulePermissions}) {
  useEffect(() => {
    getAttendanceConsiderList();
  }, []);
  const [attendanceConsiderData, setAttendanceConsiderData] = useState({
    columns: [
     
      {
        Header: "NAME",
        accessor: "employee_name",
      },
      {
        Header: 'Mis-Punch Date ',
        accessor: "created_at",
        Cell: ({ row }) => {
          return (
            <span>
              {new Date(row.original?.attendance_list?.created_at).toLocaleDateString("en-US", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
              })}
            </span>
          );
        },
      },
      {
        Header: "Duration",
        accessor: "duration",
        Cell: ({row}) => (<span>
            {row.original?.attendance_list?.duration}
        </span>)
      },
      {
        Header: "COMMENT",
        accessor: "comment",
      },

      {
        Header: "Action",
        accessor: "inout",
        Cell: ({ row }) => (
          <div style={{ display: "flex", alignItems: "center" }}>
            <Tooltip title="Approve">
              <IconButton
                aria-label="info"
                size="small"
                onClick={() => {
                    handleApproval(row.original?.id)
                }}
              >
                <ApprovalRounded/>
              </IconButton>
            </Tooltip>
          
            {/* <Tooltip title="Add Status">
              <IconButton
                aria-label="Add Status"
                size="small"
                onClick={() => {
                  setStatusDialog(true);
                }}
              >
                <AddIcon />
              </IconButton>
            </Tooltip> */}
          </div>
        ),
      },
    ],
    rows: [],
  });
  async function handleApproval(id) {
    var res = await ApiCalls.patchAttendanceCorrection(id,{status:"approved"});
    if(res.success){
        getAttendanceConsiderList();
    }
  }
  async function getAttendanceConsiderList() {
    var res =  await ApiCalls.getattendanceConsiderRequestList();

    if (res.success) {
        attendanceConsiderData.rows = res.data;
        setAttendanceConsiderData({...attendanceConsiderData})

    }
  }
  return (
    <DashboardLayout>
     <DashboardNavbar />
      <MDBox>
        <Card>
					<MDBox sx={{ display: "flex", alignItems: "center", gap: 2, padding: 3 }}>
						<MDBox
							sx={{
								width: 48,
								height: 48,
								borderRadius: "16px",
								display: "grid",
								placeItems: "center",
								background: `linear-gradient(135deg, ${colors.primary.main} 0%, ${colors.info.main} 100%)`,
								color: colors.white.main,
							}}
						>
							<CallMissedOutgoingRounded />
						</MDBox>
						<MDBox sx={{ display: "flex", flexDirection: "column" }}>
							<MDTypography
								variant="h4"
								sx={{ letterSpacing: "-0.03em" }}
							>
								Miss punch Approvals
							</MDTypography>
							<MDTypography variant="body2" color="text" sx={{ mt: 0.5 }}>
								Track and manage the miss-punches raised by employees
							</MDTypography>
						</MDBox>
					</MDBox>
          <MDBox>
            <DataTable table={attendanceConsiderData} entriesPerPage={false}></DataTable>
          </MDBox>
        </Card>
      </MDBox>
    </DashboardLayout>
  );
}
